import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../assets/css/auth.css';
import logo from '../../assets/images/logo.png';
// import { headers, Login } from '../../Redux/services/Apis';
import { LoginApi } from '../../Redux/Auth/Auth_Action';
import { toast } from 'react-toastify';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const SignIn = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const reduxState = useSelector((state) => state?.Auth);

    // console.log(reduxState);

    const [state, setState] = useState({
        email: (reduxState?.rememberMe) ? reduxState?.user?.email : "",
        password: (reduxState?.rememberMe) ? reduxState?.password : "",
    });

    const [checked, setChecked] = useState(false);
    const [pathNameState, setPathNameState] = useState(null);

    const InputVal = (e) => {
        let { name, value } = e.target;
        setState({ ...state, [name]: value })
    }

    const handleChange = (event) => {
        setChecked(event.target.checked);
    };

    let infoData = {
        email: state.email,
        password: state.password,
    }

    useEffect(() => {
        setPathNameState(location?.state?.from?.pathname);
    }, []);

    const SubmitData = async (e) => {
        e.preventDefault();
        dispatch(LoginApi(infoData, checked))
            .then((res) => {
                if (pathNameState === "/packages") {
                    navigate(`${pathNameState}`);
                } else {
                    navigate(`/`);
                }
            })
            .catch((e) => {
                // toast.error('invalid credientials');
                console.log(e);
            })
    }

    return (
        <div className='authentication signin pos-rel'>
            <span onClick={() => { navigate(-1) }} className='bck_btn'>
                <ArrowBackIosIcon /> Back
            </span>
            <div className='auth-box-container'>
                <div className='auth-box'>
                    <form method="post" onSubmit={SubmitData}>
                        <div className='row'>
                            <div className='col-lg-2 align-self-center'>
                            </div>
                            <div className='col-lg-8 pt-3 mb-4 text-center'>
                                <img onClick={() => { navigate('/') }} alt="logo" className='logo-top mt-5 cursor_pointer' src={logo} />
                            </div>
                            <div className='col-lg-12 mt-4 rez-auth-mt0 text-center'>
                                <p className='f-mon-bold f-45 mb-3 mb-rez-0-auth-head'>Sign In</p>
                                <p className='mb-0 f-28 f-mon-reg'>Welcome Back to <span className='f-mon-bold'>Prediction Dog</span> </p>
                                <p className='mb-0 f-25 f-mon-reg lh-01'>Where You will get betting tips</p>
                                <p className='f-16 f-mon-reg mb-4 mt-2'>Not a member ? <span onClick={() => { navigate('/signup') }} className='grn_clr ml-1 f-20 highlightx'>Sign Up</span></p>
                                <input
                                    required
                                    value={state.email}
                                    name="email"
                                    onChange={InputVal}
                                    type='text' placeholder='Email' className="form-control f-16 f-mon-reg mt-4 rounded-0 inpt-fld-auth" />
                                <input
                                    required
                                    value={state.password}
                                    name="password"
                                    onChange={InputVal}
                                    type='password' placeholder='Password' className="form-control mt-3 f-16 f-mon-reg rounded-0 inpt-fld-auth" />
                            </div>
                            <div className='col-lg-6 mt-3 mb-3'>
                                <div className="form-group pos-rel">
                                    <input
                                        checked={checked}
                                        onChange={handleChange}
                                        type="checkbox" id="html" />
                                    <label htmlFor="html" className='grn_clr f-14 f-mon-reg'>Remember Me</label>
                                </div>
                            </div>
                            <div className='col-lg-6 text-rght mt-3 mb-3 text-res-left'>
                                <span onClick={() => { navigate("/forgotpassword") }} className='grn_clr f-14 f-mon-reg'>Forgot Password ?</span>
                            </div>
                            <div className='col-lg-12'>
                                <button type='submit' className='btn btn-light form-control bt-auth '>SIGN IN</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default SignIn;